import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const html =
    typeof document === 'undefined' ? null : document.querySelector('html');

/**
 * Sets classes on the HTML element for shading.
 *
 * @function
 * @param    {boolean} filters if true we set an additional filters class which changes the z-index of the shade so it
 *                              appears under the header but on top of the main content.
 * @param    {boolean} menu    if true we set an additional 'mainmenu' class which changes the z-index of the shade so
 *                              it appears under the main menu.
 */
function shadeMe(filters, menu) {
    html.classList.add('shaded');
    if (filters) {
        html.classList.add('filters');
    }
    if (menu) {
        html.classList.add('mainmenu');
    }
}

/**
 * Remove all shade related html tag classes.
 *
 * @function
 * @returns  {[type]} [description]
 */
function unshadeMe() {
    html.classList.remove('shaded');
    setTimeout(() => {
        html.classList.remove('filters');
        html.classList.remove('mainmenu');
    }, 250);
}

/**
 * Shade component. Always present, CSS hides it behind the main page and makes it unclickable.
 *
 * @function
 * @param       {object} shade    useState object controlling the shade
 * @param       {function} setShade useState function to set the shade object to control the shade.
 * @constructor
 */
function Shade({ shade, setShade }) {
    const [open, setOpen] = useState(false);

    /**
     * Handle click on shade. Usually this will close the shade, but a custom function can be passed in to do something
     * different.
     *
     * @function
     * @param    {Event} e  original click/touch event.
     * @returns  {null}
     */
    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof shade !== 'object' || typeof setShade !== 'function') {
            return;
        }

        if (typeof shade.onClick !== 'function') {
            setShade({ closer: 'Shade', shade: false });
        } else {
            shade.onClick();
        }
    }

    useEffect(() => {
        if (typeof shade !== 'object') {
            return;
        }

        //console.log('shade changed', shade);

        if (shade.shade) {
            if (open === false) {
                //only do stuff if the shade isn't already open.
                //console.log('opening shade');
                setOpen(true);
                shadeMe(shade.filters, shade.menu);
            }
        } else {
            if (open === true) {
                //only do stuff if the shade is already open.
                setOpen(false);
                //console.log('closing shade');
                unshadeMe();
            }
        }
    }, [shade.shade]);

    return <div className='shade' onClick={(e) => handleClick(e)} />;
}

Shade.propTypes = {
    shade: PropTypes.object,
    setShade: PropTypes.func
};

export { Shade };
